import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';

import { SwipeManagerService } from './swipe-manager.service';

@Directive({
    selector: '[autoCloseSwipe]',
})
export class AutoCloseSwipeDirective implements OnInit, OnDestroy {
    private swipeManager = inject(SwipeManagerService);
    private elementRef = inject(ElementRef);
    private clickListener = (event: Event) => {
        if (this.swipeManager.hasActiveSwipe()) {
            const target = event.target as HTMLElement;
            const isSwipeAction = target?.closest('[swipe-remove-action]');

            if (!isSwipeAction) {
                this.swipeManager.closeActiveSwipe();
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        }
    };

    ngOnInit(): void {
        this.elementRef.nativeElement.addEventListener('click', this.clickListener, true);
    }

    ngOnDestroy(): void {
        this.elementRef.nativeElement.removeEventListener('click', this.clickListener, true);
    }
}
